import {ArticleFormStep} from "../contexts/article-form-context";
import {ReactComponent as SpecialistIcon} from "@assets/icons/specialist.svg";
import {ReactComponent as RelatedArticlesIcon} from "@assets/icons/related-articles.svg";
import {ReactComponent as AuthorIcon} from "@assets/icons/author.svg";
import {ReactComponent as PencilIcon} from "@assets/icons/pencil.svg";

export const formArticleStep = [
    {
        key: ArticleFormStep.CONTENT,
        icon: PencilIcon,
        label: 'Treść artykułu',
    },
    {
        key: ArticleFormStep.EXERCISES,
        icon: RelatedArticlesIcon,
        label: 'Ćwiczenia',
    },
    {
        key: ArticleFormStep.SPECIALIST,
        icon: SpecialistIcon,
        label: 'Polecany specjalista',
    },
    {
        key: ArticleFormStep.RELATED,
        icon: RelatedArticlesIcon,
        label: 'Powiązane artykuły',
    },
    {
        key: ArticleFormStep.AUTHOR,
        icon: AuthorIcon,
        label: 'Autor',
    },
];
